export const experienceData = [
    {
        id: 1,
        company: 'SimpleCRM',
        jobtitle: 'Project intern',
        startYear: 'May, 2023',
        endYear: 'Jul, 2023'
    },
    {
        id: 2,
        company: 'DoTA (Club @BPHC)',
        jobtitle: 'Frontend Developer',
        startYear: 'Jul, 2022',
        endYear: 'Aug, 2024'
    },
]